@if (showMessage()) {
  <div class="alert alert-{{ alertColor() }} alert-dismissible {{ andClass() }} fade show" role="alert">
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="closeButton()"></button>
    <ng-content></ng-content>
  </div>
}
